<h2 class="component-header">
    <i class="icon icon-arrow-left" (click)="back.emit()"></i>
    <span>{{ title() }}</span>
</h2>
